import { useCallback, useEffect, useState } from 'react'

const DISMISSED_KEY = 'pds_waitlist_popup_dismissed'
const SUBMITTED_KEY = 'pds_waitlist_popup_submitted'

function isStored(key: string): boolean {
  try {
    return typeof window !== 'undefined' && localStorage.getItem(key) === '1'
  } catch {
    return false
  }
}

type Options = {
  delayMs?: number
  authLoading: boolean
  isLoggedIn: boolean
}

export function useLandingWaitlistPopup({
  delayMs = 8000,
  authLoading,
  isLoggedIn,
}: Options): { open: boolean; dismiss: () => void; markSubmitted: () => void } {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (authLoading || isLoggedIn) return
    if (isStored(DISMISSED_KEY) || isStored(SUBMITTED_KEY)) return

    const id = window.setTimeout(() => setOpen(true), delayMs)
    return () => window.clearTimeout(id)
  }, [authLoading, isLoggedIn, delayMs])

  const dismiss = useCallback(() => {
    try {
      localStorage.setItem(DISMISSED_KEY, '1')
    } catch {
      /* ignore */
    }
    setOpen(false)
  }, [])

  const markSubmitted = useCallback(() => {
    try {
      localStorage.setItem(SUBMITTED_KEY, '1')
    } catch {
      /* ignore */
    }
    setOpen(false)
  }, [])

  return { open, dismiss, markSubmitted }
}
